import { connect } from 'react-redux';
import {
  fetchAdmins,
  initAdminsSearchParams,
} from '../../../redux/actions';
import searchConfigs, { ADMIN_USERS_SEARCH } from '../../lib/searchBarConfig';
import StructuredSearchbarForm from './StructuredSearchbarForm';

// eslint-disable-next-line import/no-named-as-default-member
const searchCategories = searchConfigs[ADMIN_USERS_SEARCH];
const mapStateToProps = state => ({
  isFetching: state.adminsReducer.isFetching,
  searchParams: state.adminsReducer.searchParams,
});

const mapDispatchToProps = {
  submitSearch: fetchAdmins,
  initSearchParams: initAdminsSearchParams,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  searchCategories,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(StructuredSearchbarForm);



// WEBPACK FOOTER //
// ./src/js/common/components/Searchbar/AdminsSearch.js